export const environment = {
  production: false,
  apiUrl: 'http://localhost:3000/graphql',
  cognito: {
    region: 'eu-west-2',
    userPoolId: 'eu-west-2_A6bYm5RXr',
    clientId: '34u97gs3vq7o49em45g9c37tik',
  },
  filestack: {
    api: 'ADFgKR8OMTVur7o7iAIbrz',
    bucket: {
      location: 's3',
      region: 'eu-west-2',
      container: 'saltus-partner-portal-uploads-dev',
      path: '/',
    },
  },
};
